import Vue from "vue";
import jwt_decode from 'jwt-decode';

const resourceCustomer = {
  namespaced: true,
  state: {
    profile: {}
  },
  mutations: {
    SET_AUTH( state, payload ){
      if( payload ){
        localStorage.setItem( 'eleToken', payload );
        const decode = jwt_decode( payload );
        Object.entries( decode ).forEach( entry => {
          Vue.set( state.profile, entry[0], entry[1] );
        });

        localStorage.setItem( 'profile', JSON.stringify(state.profile) );

      }else{
        localStorage.removeItem( "eleToken" );
        Object.entries( state.profile ).forEach( entry => {
          Vue.delete( state.profile, entry[0] );
        });

        localStorage.removeItem( "profile" );
        // 여기서 없애버리고.
      };
    },
    SET_ITEMS( state, payload ){
  //    state.items[ payload.id ] = Object.assign({}, state.items[ payload.id ], payload.data );
    },
    UNSET_ITEMS( state, payload ){

    },
    SET_LIST( state, payload ){

    },
    CLEAR_LIST( state, payload ){

    },
  },
  getters: {
    GET_ITEMS_BY_LIST: state => payload => {
      /* payload로 날아온 listName을 이용해서 state.lists를 조회 후, state.lists[ listName ].docs 를 받아오면 댐. */
    },
  },
  actions: {
    getCertification({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post('https://asia-northeast1-qprice-db76b.cloudfunctions.net/smsc', {

          "key" : "Ek*)ns$(J!hQ3Z?o<Pv[d^AfTYY!i4a{w|D[PVOZy|5}tWb?CvTVJOJNSowIZw",
          "rp" : payload.data,
          "sp" : "16681100",
          "mg" : "[" + payload.code + "] INSUNET FC 본인확인 인증번호를 입력해주세요.",
          "sa" : "1009000"
        }).then( res => {

          return resolve( res );
        } )
        .catch( response => {  } );
      })
    },
    regist({ state, rootState, commit, dispatch }, payload ){
      return new Promise( (resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/customer/regist",{ "customer_name": payload.customer_name, "phone": payload.phone,"customer_email": payload.customer_email, "customer_social_number": payload.customer_social_number } ).then( res => {
          const { data } = res.data;
          const { token } = data;
          commit( "SET_AUTH", token );

          return resolve( res );
        }).catch( reject );
      });
    },
    registExceptCar({ state, rootState, commit, dispatch }, payload ){
      return new Promise( (resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/customer/registexceptcar",{ "customer_name": payload.customer_name, "phone": payload.phone,"customer_email": payload.customer_email, "customer_social_number": payload.customer_social_number} ).then( res => {
          const { data } = res.data;
          const { token } = data;
          commit( "SET_AUTH", token );

          return resolve( res );
        }).catch( reject );
      });
    },
    updateCustomer({ state, rootState, commit, dispatch }, payload ){
      return new Promise( (resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/customer/updatecustomer",{ "customer_id": payload.customer_id, "customer_name": payload.customer_name, "customer_email": payload.customer_email, "customer_social_number": payload.customer_social_number } ).then( res => {
          const { data } = res.data;

          return resolve( res );
        }).catch( reject );
      });
    },
    registPhone({ state, rootState, commit, dispatch }, payload ){
      return new Promise( (resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/customer/phone/regist",{  "customer_phone_number": payload.phone, "customerid": payload.customerid } ).then( res => {
          const { data } = res.data;
          const { token } = data;
          /* API data 값이 regist와 다른값임 */
          //console.log("regPh", token, data)
          //commit( "SET_AUTH", token );

          return resolve( res );
        }).catch( reject );
      });
    },
    getAuth({ state, rootState, commit, dispatch }, payload ){
      return new Promise( (resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/customer/login", { "name": payload.name, "phone": payload.phone } ).then( res => {
          const { data } = res.data;
          const { token } = data;

          // const decode = jwt_decode(token);
          // localStorage.setItem('eleToken', token)
          commit( "SET_AUTH",  token );
          return resolve( res );
        }).catch( reject );
      });
    },
    getAuthExceptCar({ state, rootState, commit, dispatch }, payload ){
      return new Promise( (resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/customer/loginexceptcar", { "phone": payload.phone, "customer_social_number": payload.customer_social_number } ).then( res => {
          const { data } = res.data;
          const { token } = data;

          // const decode = jwt_decode(token);
          // localStorage.setItem('eleToken', token)
          commit( "SET_AUTH",  token );
          return resolve( res );
        }).catch( reject );
      });
    },
    test({ state, rootState, commit, dispatch }, payload ){
      let token = localStorage.getItem( "token" );
      Vue.axios.get( rootState.config.hostName + "/v1/www/customer/test" ).then( res => {

      })
    },
    refresh({ state, rootState, commit, dispatch }){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/www/customer/test" ).then( res => {

          commit( "SET_AUTH", res.data.data.token );
          let result = {
            token : localStorage.eleToken,
            profile : state.profile,
          }

          return resolve( result );
        }).catch(reject);
      });
    },
    getItem({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/crm/customer/${payload}` ).then( res => {
          return resolve( res );
        }).catch( reject );
      });
    },
    getItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( /* endpoint */ ).then( res => {
          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },
    /*createItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( '', payload.data ).then( res => {
           commit( "SET_ITEM", res.data )
          return resolve( res );
        }).catch( reject );
      });
    },*/
    deleteItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.delete( /* endpoint */ ).then( res => {
          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },
    updateItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.put( "/v1/store/manager/", payload.data ).then( res => {

          //commit( "SET_ITEM", res.data )
          return resolve( res );
        }).catch( reject );
      });
    },
    getDistance({ rootState }, { customer_id }) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/www/customer.distance/${customer_id}`)
          .then(resolve)
          .catch(reject);
      });
    },
    getInsuranceSalesStatus({ state, rootState, commit, dispatch }, payload){
      return new Promise((resolve, reject) => {
        Vue.axios.get(rootState.config.hostName + `/v1/www/customer.insurance.sales.status/${payload}`).then( res => {
          return resolve(res);
        })
      })
    },
    getInputRequest({ state, rootState, commit, dispatch }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/www/customer.input.request/${payload}`)
          .then(resolve)
          .catch(reject);
      });
    }
  }

};

export default resourceCustomer;
